export default __webpack_public_path__ + "static/media/unreal-engine-logo.82a363c3.jpg";